<template>
    <Card class="clearfix">
        <preloader :display="loading" />
        <h2 class="mt-0">{{ $l10n.__("Préférences Générales de l'annuaire des sociétés") }}</h2>
        <el-form :model="prefForm" :rules="rules" ref="prefForm" label-position="top">
            <el-form-item
                :label="
                    $t.__('companysearch.CompanySearchPrefForm.authorized_countries_for_search')
                "
                prop="countriesAuthorize"
            >
                <el-select
                    v-model="prefForm.countriesAuthorize"
                    @remove-tag="resetDefault"
                    multiple
                    :placeholder="$t.__('companysearch.CompanySearchPrefForm.select_country')"
                    class="wp-3"
                >
                    <el-option
                        v-for="country in countriesAvailable"
                        :key="country"
                        :label="getCountryLabel(country)"
                        :value="country"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item
                :label="$t.__('companysearch.CompanySearchPrefForm.default_country_search')"
                prop="countryDefault"
            >
                <el-select
                    v-model="prefForm.countryDefault"
                    :placeholder="
                        $t.__('companysearch.CompanySearchPrefForm.select_default_country')
                    "
                >
                    <el-option
                        v-for="country in prefForm.countriesAuthorize"
                        :key="country"
                        :label="getCountryLabel(country)"
                        :value="country"
                    ></el-option>
                </el-select>
            </el-form-item>
            <p class="aleft mt-6">
                <CompassButton
                    :label="$t.__('companysearch.CompanySearchPrefForm.save_modifications')"
                    type="primary"
                    @click="submitForm('prefForm')"
                />
            </p>
        </el-form>
    </Card>
</template>

<script>
import Card from 'vcomponents/common/card/Card.vue';
import CompanySearchMixins from './CompanySearchMixins.js';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Card,
        Preloader,
    },
    mixins: [CompanySearchMixins],
    props: {
        data_countries: { type: Object, required: true },
    },
    data() {
        return {
            prefForm: {
                countriesAuthorize: this.data_countries.countriesAuthorize,
                countryDefault: this.data_countries.countryDefault,
            },
            rules: {
                countriesAuthorize: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez sélectionner un ou plusieurs pays'),
                        trigger: 'blur',
                    },
                ],
                countryDefault: [
                    {
                        required: true,
                        message: this.$l10n.__('Veuillez sélectionner un pays par défaut'),
                        trigger: 'blur',
                    },
                ],
            },
            countriesAvailable: this.data_countries.countriesAvailable,
            loading: false,
        };
    },
    methods: {
        resetDefault(countryCode) {
            if (countryCode === this.prefForm.countryDefault) {
                this.prefForm.countryDefault = '';
            }
        },
        submitForm(prefForm) {
            this.$refs[prefForm].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$ajax.post(
                        `/companysearch/prefs/save`,
                        {},
                        {
                            authorize: this.prefForm.countriesAuthorize,
                            default: this.prefForm.countryDefault,
                        },
                        (response) => {
                            this.loading = false;
                            Push.success(this.$l10n.__('Vos préférences ont bien été mise à jour'));
                        },
                        (error) => {
                            this.loading = false;
                            Push.error(
                                this.$l10n.__(
                                    'Une erreur est survenue, veuillez réessayer plus tard.',
                                ),
                            );
                        },
                    );
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
